import {
  getPasswordCriteriaRules,
  type PasswordCriterion,
} from 'app/components/flat/ui/PasswordCriteriaChecklist/passwordCriteriaRules';

const RESET_SCREEN_RULE_IDS = [
  'min-length',
  'uppercase',
  'lowercase',
  'special-char',
  'no-sequential-numbers',
];

export const FIRST_PASSWORD_RULES: PasswordCriterion[] =
  getPasswordCriteriaRules().filter((rule) =>
    RESET_SCREEN_RULE_IDS.includes(rule.id),
  );
